import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/slideIndicators.module.scss';

import type { ISlideIndicators } from './types';

export const SlideIndicators = ({
  backgroundColor,
  slides,
  currentSlide,
  setThisSlide,
}: ISlideIndicators) => {

  const slideCount: number = slides.length;
  return (
    <div className={generateClassName([styles.slideIndicatorsWrapper, styles[backgroundColor]])}>
      <div className={styles.slideIndicators}>
        {slides.map((card, cardIndex: number) => (
          <button className={generateClassName([
            styles.slideIndicatorStyles,
            styles.slideButton,
          ])} type="button" key={cardIndex} onClick={() => {setThisSlide(cardIndex);}}/>
        ))}
        <div className={generateClassName([styles.slideIndicatorStyles, styles.selectedIndicator])} style={{
          zIndex: Math.max(currentSlide + 1, 0),
          transform: `translateX(${currentSlide * 24}px)`,
        }}/>
        {[...Array(slideCount - 1).keys()].map((key) => (
          <div
            className={generateClassName([styles.slideIndicatorStyles, styles.slideIndicator])}
            style={{
              zIndex: key + 1,
              transform: key + 1 <= currentSlide ? `translateX(calc(${key} * 24px))` : `translateX(calc(${key + 1} * 24px))`,
            }}
            key={key}
          />
        ))}
      </div>
    </div>
  );
};
